import { render, staticRenderFns } from "./Habitable.vue?vue&type=template&id=cc2c5812"
import script from "./Habitable.vue?vue&type=script&lang=js"
export * from "./Habitable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports